interface Time {
    hours: number;
    minutes: number;
    seconds: number;
    ms: number;
}

const padNumber = (nb: number, length: number = 2): string =>
    String(nb).padStart(length, '0');

const timeToString = (time: Time): string => {
    const { ms, ...rest } = time;

    const formattedTime = Object.values(rest).map((value) => padNumber(value));
    const formattedMs = padNumber(ms, 3);

    return `${formattedTime.join(':')}.${formattedMs}`;
};

export const formatTime = (ms: number): string => {
    const time: Time = {
        hours: 0,
        minutes: 0,
        seconds: 0,
        ms: 0,
    };

    if (ms > 0 || !isNaN(ms)) {
        // 1. Calculate hours
        const totalSeconds = Math.floor(ms / 1000);
        time.hours = Math.floor(totalSeconds / 3600);
        const remainingSecondsAfterHours = totalSeconds % 3600;

        // 2. Calculate minutes and seconds
        time.minutes = Math.floor(remainingSecondsAfterHours / 60);
        time.seconds = remainingSecondsAfterHours % 60;

        // 3. Calculate milliseconds (the remainder)
        time.ms = ms % 1000;
    }

    return timeToString(time);
};
